// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application.js";

import RegistrationController from "./registration_controller.js";
application.register("registration", RegistrationController);

import TmpController from "./tmp_controller.js";
application.register("tmp", TmpController);

import ProductsController from "./products_controller.js";
application.register("products", ProductsController);

import CartController from "./cart_controller.js";
application.register("cart", CartController);

import CartConfirmController from "./cart_confirm_controller.js";
application.register("cart-confirm", CartConfirmController);

import MenuToggleController from "./menu_toggle_controller.js";
application.register("menu-toggle", MenuToggleController);

import CategoryScrollController from "./category_scroll_controller.js";
application.register("category-scroll", CategoryScrollController);

import ToggleController from "./toggle_controller.js";
application.register("toggle", ToggleController);

import NotificationsController from "./notifications_controller.js";
application.register("notifications", NotificationsController);

import FlashMessageController from "./flash_message_controller.js";
application.register("flash-message", FlashMessageController);

import CampaignsController from "./campaigns_controller.js";
application.register("campaigns", CampaignsController);

import TermsController from "./terms_controller.js";
application.register("terms", TermsController);

import ProductImageCarouselController from "./product_image_carousel_controller.js";
application.register("product-image-carousel", ProductImageCarouselController);

import CampaignAttributionController from "./campaign_attribution_controller.js";
application.register("campaign-attribution", CampaignAttributionController);

import PromotionTrackingController from "./promotion_tracking_controller.js";
application.register("promotion-tracking", PromotionTrackingController);
